// Import core lib dependencies.
import { createSelector } from 'reselect';

// Config.
import Config from './config/config.js';

/**
 * <pre>
 * PrivacyManagement module Selectors(s).
 *
 * Summary of responsibilities:
 *
 *  - defines reusable selectors to retrieve state properties
 * </pre>
 *
 * @memberof module:PrivacyManagement
 * @namespace
 *
 * @type {Object}
 */
const Selectors = {};

/**
 * Selector to retrieve flag to indicate whether to show the privacy consent popup.
 *
 * @memberof module:PrivacyManagement.Selectors
 *
 * @param  {Object}  state  The Redux state.
 * @return {Object}  The value of the retrieved state property.
 */
const showPrivacyPopup = state => state[Config.stateKey].showPrivacyPopup;
Selectors.getShowPrivacyPopup = createSelector([showPrivacyPopup], stateVal => {
  return stateVal;
});

/**
 * Selector to retrieve flag to indicate whether to show the cookies disabled modal message.
 *
 * @memberof module:PrivacyManagement.Selectors
 *
 * @param  {Object}  state  The Redux state.
 * @return {Object}  The value of the retrieved state property.
 */
const showCookiesDisabledModal = state => state[Config.stateKey].showCookiesDisabledModal;
Selectors.getShowCookiesDisabledModal = createSelector([showCookiesDisabledModal], stateVal => {
  return stateVal;
});

export default Selectors;
